<template>
  <Transition name="modal">
    <div v-if="showModal" class="modal-mask" @click="closeModal()">
      <div class="modal-container">
        <div class="d-flex justify-content-center p-4 background-img">
          <img src="@/assets/svgs/plazasLibresWarning.svg" class="modal-image justify-content-center" />
        </div>
        <div class="modal-title px-4 pb-2 pt-3 pb-md-0 text-center">
          <span v-if="plazasLibres === 1">
            {{ $t('reserva.plazasLibres.modal.tituloSingular', { plazasLibres: props.plazasLibres }) }}
          </span>
          <span v-else>
            {{ $t('reserva.plazasLibres.modal.tituloPlural', { plazasLibres: props.plazasLibres }) }}
          </span>
        </div>
        <div class="text-landing px-md-5 py-md-2 px-4 py-0 m-0 text-center">
          <CardOccupancyMini :max-size="maxSize" :occupants-info="occupantsInfo" />
        </div>
        <div class="modal-body text-landing px-4 pb-0 pt-2 m-0">
          <i18n-t v-if="plazasLibres === 1" keypath="reserva.plazasLibres.modal.bodySingular" tag="span">
            <strong>{{ plazasLibres }}</strong>
            <strong>{{ precioTotal }}{{ agenciaStore.getCurrency }}</strong>
          </i18n-t>
          <i18n-t v-else keypath="reserva.plazasLibres.modal.bodyPlural" tag="span">
            <strong>{{ plazasLibres }}</strong>
            <strong>{{ precioTotal }}{{ agenciaStore.getCurrency }}</strong>
          </i18n-t>
        </div>
        <div class="modal-footer px-4 py-2">
          <template v-if="!forceFillRoom">
            <MyGocuButton
              primary
              additional-class="me-md-3 mb-1"
              :label="$t('reserva.plazasLibres.modal.genteReservar')"
              @click="closeModal('submit')" />
            <MyGocuButton
              secondary
              :label="$t('reserva.plazasLibres.modal.addSuplemento')"
              @click="closeModal('cancel')" />
          </template>
          <template v-else>
            <MyGocuButton
              primary
              additional-class="mb-1"
              :label="$t('reserva.plazasLibres.modal.completarPlazas')"
              @click="closeModal()" />
            <MyGocuButton
              secondary
              :label="$t('reserva.plazasLibres.modal.addSuplemento')"
              @click="closeModal('cancel')" />
          </template>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
  import CardOccupancyMini from '@/modules/viajesGrupos/components/CardOccupancyMini.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import { computed } from 'vue';
  import { agenciaStoreModule } from '@/store_pinia/agencia';

  const props = defineProps({
    show: Boolean,
    plazasLibres: {
      type: Number || String,
      default: '',
    },
    precioTotal: {
      type: Number || String,
      default: '',
    },
    maxSize: {
      type: Number,
      default: 0,
      required: false,
    },
    occupantsInfo: {
      type: Array,
      default: () => [],
      required: false,
    },
    forceFillRoom: {
      type: Boolean,
      default: false,
      required: false,
    },
  });

  const emit = defineEmits(['onClose', 'onSubmit', 'onCancel']);

  const agenciaStore = agenciaStoreModule();

  function closeModal(action) {
    if (action === 'submit') {
      emit('onSubmit');
    } else if (action === 'cancel') {
      emit('onCancel');
    }
    emit('onClose');
  }

  const showModal = computed(() => props.show);
</script>

<style scoped lang="scss">
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(var(--bs-black-rgb), 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    max-width: 600px;
    width: 90vw;
    background-color: var(--landing-background-color, var(--bs-white));
    box-shadow: 0 2px 8px rgba(var(--bs-black-rgb), 0.33);
    transition: all 0.3s ease;
    border-radius: var(--bs-border-radius-xl);
    padding: 0 !important;

    @media screen and (max-width: 768px) {
      max-width: 95vw;
      min-width: unset;
    }
  }

  .modal-body {
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 15px;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      width: 90%;
    }
  }

  .modal-title {
    color: #e54a5c;
    font-size: 24px;
    font-weight: 700;

    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin: 10px 0;

    @media screen and (max-width: 768px) {
      flex-direction: column-reverse;
      align-items: center;
      gap: 10px;
    }
  }

  .background-img {
    background-color: #ffd2d2;
    border-radius: var(--bs-border-radius-xl) var(--bs-border-radius-xl) 0 0;
  }
</style>
